import { styled } from '@mui/material';
import * as React from 'react';
import * as UnifyIcons from 'src/components/UnifyIcons';
import { Link, type LinkProps } from '../Link';

/**
 * Deprecate props that aren't supported in Unify.
 */
export type UnsupportedProps = {
  /**
   * @deprecated Unsupported prop: Use the color property in sx with getToken instead.
   */
  color?: LinkProps['color'];
};

type CardHeaderTitleLinkSlotProps = Omit<LinkProps, keyof UnsupportedProps> &
  UnsupportedProps & {
    ownerState?: unknown;
    as?: React.ElementType;
  };
export const CardHeaderTitleLink = React.forwardRef<
  HTMLAnchorElement,
  CardHeaderTitleLinkSlotProps
>(function CardHeaderTitleLink(props, ref) {
  // MUI injects ownerState and as when a component is used via slots/slotProps.
  // We swallow them here so the component can safely dropped into the title slot.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ownerState: _ownerState, as: _as, ...rest } = props;

  return (
    <CardHeaderTitleLinkRoot
      ref={ref}
      {...rest}
      underline="none"
      color="inherit"
    >
      <span className="UnifyCardHeaderTitleLink-Text">{rest.children}</span>
      <UnifyIcons.ChevronRight className="UnifyCardHeaderTitleLink-Chevron" />
    </CardHeaderTitleLinkRoot>
  );
});

const CardHeaderTitleLinkRoot = styled(Link, {
  name: 'UnifyCardHeaderTitleLink',
  slot: 'Root',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  '&:hover, &:visited, &:visited:hover': {
    color: 'inherit',
  },

  '.UnifyCardHeaderTitleLink-Text': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },

  '.UnifyCardHeaderTitleLink-Chevron': {
    flexShrink: 0,
    paddingLeft: theme.spacing(0.5),
    fontSize: 'inherit',
  },
}));
